import { SpeakerMultipleIcon } from './SpeakerMultipleIcon';

/**
 * author: Michael Richins
 * id 6CBEB113-DF44-4DCE-A490-5AAD4766CE28
 * name speaker-multiple
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/speaker-multiple.svg
 * tags
 * - Audio 
 */
export const SpeakersIcon = SpeakerMultipleIcon;
export default SpeakersIcon